import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.6.9/js/sparta-ui-layers-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import spartaTemplates from "modules/global/global-social-module/6.5.0/js/templates";
import "css!modules/global/global-social-module/6.5.0/css/global-social-module.scss.css";







export default class globalSocialModuleJS extends Module {
  init() {
    const genericURL = document.querySelector("[rel='canonical']")
      ? document.querySelector("[rel='canonical']").href
      : window.location.href;


    const defaults = {
      socialDebug: false,
      socialEnabled: "true", 
      socialType: "follow",
      socialTarget: ".boa-social-target", 
      $socialTarget: "",
      socialModule: ".boa-social-module", 
      $socialModule: "",
      socialLoader: ".boa-social-loader", 
      $socialLoader: "",
      branding: "default",
      lang: "en",
      content: {},
      platform: "sparta",
      site: "",
      externalSite: false,
      runtimeConfig: {},
      dataCollection: {
        cmEnabled: false,
        currentPageURL: "",
        currentPageID: "",
        pageCategoryID: "ENT:Tool:Social" 
      },
      networks: {
        twitter: {
          sharing: {
            link: "https://twitter.com/intent/tweet?text=%TITLE%&url=%URL%",
            url: genericURL,
            title: ""
          }
        },
        facebook: {
          sharing: {
            link:
              "https://www.facebook.com/sharer/sharer.php?u=%URL%&title=%TITLE%&description=%SUMMARY%&picture=%PICTURE%",
            url: genericURL,
            title: "",
            summary: "",
            picture: ""
          }
        },
        linkedin: {
          sharing: {
            link: "https://www.linkedin.com/shareArticle?&mini=true&ro=false&url=%URL%&title=%TITLE%&summary=%SUMMARY%",
            url: genericURL,
            title: "",
            summary: ""
          }
        }
      }
    };


    defaults.lang = $("html").attr("lang") === "es-US" ? "es" : "en";












    [].slice.call(document.querySelectorAll("[name^='sparta:url']")).forEach(value => {
      const propertyArray = value.attributes["name"].value.split(":");
      const currentNetwork = propertyArray[propertyArray.length - 1].toLowerCase();
      if (defaults.networks[currentNetwork] && defaults.networks[currentNetwork].sharing) {
        defaults.networks[currentNetwork].sharing.url = value.attributes["content"].value;
      }
    });


    let tempSettings = defaults;
    _.merge(tempSettings, defaults);
    this.settings = _.merge(tempSettings, this.settings);


    if (this.settings.$socialModule) {
      $this.settings.$socialTarget = $(this.settings.socialTarget, this.settings.$socialModule);
    } else if (Array.isArray(this.applicationContainer)) {
      let targets = [];

      this.settings.containerTargetArr = [];

      this.applicationContainer.forEach((currentContainer, index) => {
        let currentTarget = $(this.settings.socialTarget, currentContainer);
        this.settings.containerTargetArr[index] = currentContainer;
        if (currentTarget && currentTarget.length === 1) {
          targets.push(currentTarget[0]);
        }
      });

      this.settings.$socialTarget = $(targets);
    } else if (!this.isWidget) {
      this.settings.$socialTarget = $(this.settings.socialTarget, this.settings.target);
    } else {
      this.settings.$socialTarget = $(this.settings.socialTarget, this.applicationContainer);
    }

    const jcrData = this.settings.$socialTarget.data("config") || {};


    _.merge(this.settings, jcrData, this.params, this.settings.moduleInfo.options);


    this.isSharing = this.settings.socialType === "sharing";

    if (this.isSharing) {
      this.setupShareLinks();
    }


    if (
      this.settings.dataCollection &&
      this.settings.dataCollection.pageCategoryID &&
      this.settings.dataCollection.pageCategoryID === defaults.dataCollection.pageCategoryID
    ) {
      this.settings.dataCollection.pageCategoryID += this.settings.socialType === "follow" ? "Follow" : "Share";
    }


    this.settings.analyticsId =
      this.settings.analyticsId && this.settings.analyticsId
        ? `_${this.settings.analyticsId.trim()}`
        : this.settings.analyticsId || "";




    if (
      !this.settings.socialEnabled ||
      this.settings.socialEnabled === "false" ||
      this.settings.enableSocialContent === false ||
      (this.settings.runtimeConfig && this.settings.runtimeConfig.socialEnabled === false)
    ) {
      this.settings.$target.append('<span class="socialIsDisabled"></span>');
      return;
    }

    [].slice.call(this.settings.$socialTarget).forEach((appContainer, index, arr) => {
      this.createSocialModule(this.isSharing, $(appContainer), arr.length > 1 ? index + 1 : NaN);
    });
  }

  setupShareLinks() {
    Object.keys(this.settings.networks).forEach(networkName => {
      let currentNetwork = this.settings.networks[networkName];
      if (currentNetwork && currentNetwork.sharing && currentNetwork.sharing.link) {
        let currentShare = currentNetwork.sharing;

        currentShare.link = currentShare.link.replace("%URL%", currentShare.url || "");
        currentShare.link = currentShare.link.replace("%TITLE%", currentShare.title || "");
        currentShare.link = currentShare.link.replace("%SUMMARY%", currentShare.summary || "");
        currentShare.link = currentShare.link.replace("%PICTURE%", currentShare.picture || "");
      }
    });
  }


  createSocialModule(useShareLinks, appContainer, itemIndex = NaN) {
    let html = `
            <div class="boa-social boa-social--follow boa-social--clearfix">
            <${this.settings.headerTag} class="boa-social--header">${this.settings.content[useShareLinks ? "share" : "connectWithUs"]}</${this.settings.headerTag}>`;


    let structuredMarkup = `
            <div itemscope="itemscope" itemtype="http://schema.org/Organization">
            <link style="display:none" itemprop="url" href="https://www.bankofamerica.com"></link>`;


    for (var i = 0; i < this.settings.networkOrder.length; i++) {
      var network = this.settings.networkOrder[i];
      var networkObj = this.settings.networks[network],
        linkID = `social_${this.settings.socialType.toLowerCase()}_${networkObj.class}${
          this.settings.analyticsId
        }${itemIndex || ""}`,
        link;


      if (useShareLinks) {
        if (networkObj.sharing && networkObj.sharing.link) {
          link = networkObj.sharing.link;
        } else {
          continue; 
        }
      } else {

        if (network === "twitter") {
          link = networkObj.links["@BankofAmerica"] || {};
          link = link.link;
        } else {
          link = networkObj.links[network].link;
        }
      }


      if (typeof link === "undefined") {
        link = "";
      }


      if (!networkObj.enabled || (this.settings.runtimeConfig && this.settings.runtimeConfig[network] === false)) {
        continue;
      }


      structuredMarkup += `<a style="display:none" itemprop="sameAs" href="${link}">${networkObj.name}</a>`;

      html += `<a href="javascript:void(0);" id="${linkID}" data-network="${
        networkObj.class
      }" class="boa-social--network boa-social--${networkObj.class}" aria-label="${
        this.settings.content[useShareLinks ? "shareOn" : "connectWithUsOn"]
      } ${networkObj.name} ${this.settings.content.adaOpen}">
        ${networkObj.svg}
        </a>`;
    }

    structuredMarkup += `</div>`;
    html += `</div>` + structuredMarkup;


    appContainer.html(html);

    let networkClickHandler = function(event) {
      this.openSocialLayer.call(this, event, itemIndex, appContainer, useShareLinks);
    };


    appContainer.on("click", ".boa-social--network", networkClickHandler.bind(this));


    this.updateLinksDataCollection();
  }


  openSocialLayer(event, itemIndex, currentContainer, useShareLinks) {

    let $this = $(event.currentTarget);
    const modalId = `boaSocialModal${this.settings.analyticsId}${itemIndex || ""}`;


    if ($(`#${modalId}SpartaUILayer`).length > 0) {
      $(`#${modalId}SpartaUILayer`).remove();
    }


    let network = $this.data("network");
    let networkObj = this.settings.networks[network];
    let networkName = networkObj.name;
    let networkLink, modalHeader;
    let modalBranding = this.settings.branding;
    let modalContent = "";


    let hideInterstitial = false;
    let hideInterstitialClass = "boa-social--hide-interstitial";


    const primaryButton = "spa-btn spa-btn--small spa-btn--primary";
    const secondaryButton = "spa-btn spa-btn--small spa-btn--secondary";

    if (this.isSharing) {
      networkLink = networkObj.sharing.link;
    } else {

      if (network === "twitter") {
        networkLink = networkObj.links["@BankofAmerica"] || {};
        networkLink = networkLink.link;
      } else {
        networkLink = networkObj.links[network].link;
      }
    }

    modalHeader = useShareLinks ? networkObj.content.sharingHeading : networkObj.content.connectHeading;
    modalContent += `<div class="boa-social--interstitial ${hideInterstitial ? hideInterstitialClass : ""}">${
      this.settings.content.interstitial1
    }${networkName}${this.settings.content.interstitial2}</div>`;


    let modal = `
          <div id="${modalId}" class="boa-social--modal" data-nosnippet
               data-options=\'{"type":"modal", "width": 500, "branding": "${modalBranding}", "adaCloseFocus": true, "closeTriggers": ["#${modalId} .boa-social--button"]}\'>
               <${this.settings.headerTag} class="boa-social--header">${modalHeader}</${this.settings.headerTag}>
               <div class="flex-modal-main-content content">${modalContent}</div>
               <div class="boa-social--buttons ${hideInterstitial ? hideInterstitialClass : ""}">
                 <a target="_new" id="${modalId}_Continue" name="${modalId}_Continue${networkName}" class="boa-social--button ${primaryButton}"
                    href="${networkLink}">
                    <span>${this.settings.content.continue}${networkObj.name}</span>
                 </a>
                 <a id="${modalId}_Cancel" name="${modalId}_Cancel${networkName}" class="boa-social--button btn-bofa-noRight ${secondaryButton}"
                    href="javascript:void(0)">
                    <span>${this.settings.content.return}</span>
                 </a>
                 <div class="clearboth"></div>
               </div>
          </div>`;

    let modalEvent = {
      currentTarget: $this,
      $applicationContainer: undefined
    };

    if (this.applicationContainer && this.applicationContainer.length) {
      const targetAppContainer = this.settings.containerTargetArr[itemIndex - 1];
      $(targetAppContainer).after(modal);
      modalEvent.$applicationContainer = $(targetAppContainer);
    } else {
      currentContainer.after(modal);
    }

    if (this.settings.platform === "sparta") {
      spartaUILayersUtility.openLayer($(`#${modalId}`), modalEvent);

      let uiModalId = modalId;
      spartaEventsUtility.sub(
        `${spartaUILayersUtility.EVENTS.MODAL_CLOSED}:${uiModalId}`,
        function(event) {
          if (event.data.contentId === uiModalId) {
            spartaEventsUtility.unsubByEvent(`${spartaUILayersUtility.EVENTS.MODAL_CLOSED}:${uiModalId}`);
            this.modalCloseDataCollection();
          }
        }.bind(this)
      );
    } else if (this.settings.platform === "borneo") {
      $(`${modalId}`).boaFlexModal({
        width: 500,
        closeTriggers: $(`#${modalId} .boa-social--button`),
        onClose: function() {
          this.modalCloseDataCollection();
        }
      });
    }


    this.modalOpenDataCollection(networkObj);


    this.updateLinksDataCollection();
  }


  setupDataCollection() {
    if (typeof cmSetStaging === "function") {
      this.settings.dataCollection.cmEnabled = true;
      this.settings.dataCollection.currentPageURL = window.location.href;
      this.settings.dataCollection.currentPageID = cG7.cM0[cm_ClientID];

      this.debug(
        "_setupDataCollection() save current page id for later.  cG7.cM0[cm_ClientID] = " + cG7.cM0[cm_ClientID]
      );
    }
  }


  modalOpenDataCollection(networkObj) {

    this.setupDataCollection();


    if (typeof cmCreatePageviewTag === "undefined" && typeof bactm_cmCreatePageviewTag === "function") {
      var cmCreatePageviewTag = bactm_cmCreatePageviewTag;
    }
    if (typeof cmCreateManualLinkClickTag === "undefined" && typeof bactm_cmCreateManualLinkClickTag === "function") {
      var cmCreateManualLinkClickTag = bactm_cmCreateManualLinkClickTag;
    }

    if (
      this.settings.dataCollection.cmEnabled &&
      typeof cmCreatePageviewTag === "function" &&
      typeof cmCreateManualLinkClickTag === "function"
    ) {

      this.debug(networkObj);

      cmCreatePageviewTag(
        networkObj.pageID,
        null,
        null,
        this.settings.dataCollection.pageCategoryID,
        false,
        false,
        null,
        false,
        false,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.settings.dataCollection.currentPageURL,
        null
      );
      cmCreateManualLinkClickTag("javascript:void(0)", this.settings.dataCollection.currentPageID, networkObj.pageID);

      this.debug("_modalOpenDataCollection() - call cmCreatePageviewTag & cmCreateManualLinkClickTag");
    }
  }


  modalCloseDataCollection() {

    if (this.settings.dataCollection.cmEnabled) {
      window.setTimeout(
        function() {
          cG7.cM0[cm_ClientID] = this.settings.dataCollection.currentPageID;
          this.debug("_modalCloseDataCollection() reset page id.  cG7.cM0[cm_ClientID] = " + cG7.cM0[cm_ClientID]);
        }.bind(this),
        500
      );
    }
  }


  updateLinksDataCollection() {
    if (typeof cX === "function") {
      cX("onload");
      this.debug("_updateLinksDataCollection(): cX scan for new links");
    }
  }

  debug(msg) {
    if (window.console && this.settings.socialDebug === true) {
      console.log(msg);
    }
  }
}
